export default __webpack_public_path__ + "static/media/rk-white.9818209b.svg";